<igx-grid #gridListadoDoc id="gridListadoDoc" [data]="listaArchivos" [width]="'100%'" [height]="'100%'"
          [sortingOptions]="sortingOptions" (doubleClick)="doubleClick($event)" [allowFiltering]="true"
          [filterMode]="'excelStyleFilter'" [rowSelection]="rowSelectionSingle">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}"
                          (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpciones [arrayDatosAVer]="[6]"
                             (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Documento" header="{{'GRIDS.DOCUMENTOS.COL_DOCUMENTOS' | translate}}"
              title="{{'GRIDS.DOCUMENTOS.COL_DOCUMENTOS' | translate}}" minWidth="300px" [dataType]="'string'"
              [sortable]="true" [resizable]="true" [editable]="false" [hasSummary]="true"
              [summaries]="'filasSummary' | summaryPipeNeo" />
  <igx-column field="TipoDocumento" header="{{'GRIDS.DOCUMENTOS.COL_TIPO_DOCUMENTO' | translate}}"
              title="{{'GRIDS.DOCUMENTOS.COL_TIPO_DOCUMENTO' | translate}}" width="220px" [dataType]="'string'"
              [sortable]="true" [resizable]="true" [editable]="false" />
  <igx-column field="Neodata" header="{{'GRIDS.DOCUMENTOS.COL_NEODATA' | translate}}"
              title="{{'GRIDS.DOCUMENTOS.COL_NEODATA' | translate}}" width="160px" [dataType]="'boolean'"
              [sortable]="true" [resizable]="true" [editable]="false" />
</igx-grid>

